/**
 * Tutorial guidato dell'elenco Template email.
 *
 * Il piu' in alto porta dritto alla pagina del nuovo modello. I tre pallini della
 * riga si raccontano illuminando il pulsante, non la voce dentro il menu. Aprire il menu
 * dal tutorial non e' affidabile: il click programmatico e il click su "Avanti"
 * arrivano a `document` a distanza di un soffio, e il menu appena aperto legge il
 * secondo come un click fuori e si richiude da solo. Il pulsante invece c'e'
 * sempre, e il testo dice cosa ci si trova dentro.
 */
const SCOPE = '[data-tour-scope="email-templates"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopEmailTemplatesTour() {}

export function createEmailTemplatesTourSteps() {
	return [
		{
			body: "Qui stanno i modelli delle email che il sito manda da solo: la conferma d'ordine, il cambio di stato, il recupero della password. Non si spedisce niente da questa pagina, si scrive cosa dira' l'email quando partira'.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I modelli delle email',
		},
		{
			body: "Ogni riga e' un modello: la tipologia - cioe' l'evento che fa partire l'email - con lo stato collegato quando serve, l'oggetto nella lingua predefinita e le bandierine delle lingue. Una bandierina sbiadita e' una lingua ancora senza oggetto o testo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina del nuovo modello: li' scegli l'evento, scrivi oggetto e testo e salvi con il pulsante in fondo. Annulla riporta qui, con l'elenco come l'avevi lasciato. La pagina ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un modello',
		},
		{
			body: "I tre pallini a inizio riga aprono Modifica, che porta alla pagina del modello, ed Elimina, che chiede conferma prima di cancellare. Attenzione a Elimina: se togli il modello di un evento, per quell'evento il sito smette di mandare l'email.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
		{
			body: "Il + apre l'anteprima dell'email lingua per lingua, dice quali traduzioni mancano e quali segnaposto usa il testo, avvisando se una lingua ne ha qualcuno in meno delle altre.",
			key: 'expand',
			missing: 'skip',
			placement: 'right',
			target: at('expand'),
			title: "Vedere l'email senza aprirla",
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
